import TaskPaneErrorType from '../store/schema/TaskPaneErrorType';
import TaskPaneType from '../store/schema/TaskPaneType';
import { getTaskPaneRunningInstance } from '../utils/taskPaneUtils';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'updatePersistentTaskPaneError',
    function updatePersistentTaskPaneError(errorType: TaskPaneErrorType) {
        const persistentTaskPane = getTaskPaneRunningInstance(TaskPaneType.Persistent);
        if (persistentTaskPane) {
            persistentTaskPane.errorType = errorType;
        }
    }
);
